import api from "../../config/api";
import { createAsyncThunk } from "@reduxjs/toolkit";
import { API_ROUTES } from "../../config/apiRoutes";


/**✅ getTemplate Thunk */
export const getTemplateThunk = createAsyncThunk(
    "templates/getTemplateThunk",
    async (payload = {}, { rejectWithValue, getState }) => {
        const state = getState();
        const user = state.authentication?.user;

        if (payload.type !== "getTemplate") {
            if (state.templates?.getTemplates.length > 0) {
                return state.templates.getTemplates;
            }
        }

        try {
            const response = await api.post(API_ROUTES.TEMPLATES, {
                client_id: user?.client_id
            });

            const { message, statusCode, data } = response.data;

            if (statusCode === 200) {
                return data;
            }

            return rejectWithValue(message || "Failed to fetch Templates");
        } catch (error) {
            return rejectWithValue(
                error.response?.data?.message || error.message || "Request failed"
            );
        }
    }
);



/**✅ Create Template Thunk **/
export const createTemplateThunk = createAsyncThunk(
    "templates/createTemplateThunk",
    async ({ credentials }, { rejectWithValue, getState }) => {
        const state = getState();
        const user = state.authentication?.user;

        const payload = {
            ...credentials,
            employee_id: user?.user_id,
        };

        try {
            const response = await api.post(API_ROUTES.CREATE_TEMPLATE, payload);
            const { message, statusCode } = response.data;

            if (statusCode === 201) {
                return {
                    success: true,
                    message,
                };
            }

            return rejectWithValue(message || "Template are failed");
        } catch (error) {
            return rejectWithValue(
                error.response?.data?.message || error.message || "Template are failed"
            );
        }
    }
);


/**✅ delete Template Thunk **/
export const deleteTemplateThunk = createAsyncThunk(
    "templates/deleteTemplateThunk",
    async ({ credentials }, { rejectWithValue, getState }) => {
        const state = getState();
        const user = state.authentication?.user;

        const payload = {
            ...credentials,
            employee_id: user?.user_id,
        };

        try {
            const response = await api.post(API_ROUTES.DELETE_TEMPLATE, payload);
            const { message, statusCode } = response.data;

            if (statusCode === 200) {
                return {
                    success: true,
                    message,
                };
            }

            return rejectWithValue(message || "template failed");
        } catch (error) {
            return rejectWithValue(
                error.response?.data?.message || error.message || "template failed"
            );
        }
    }
);
